import React from 'react';
import { ProductsShowcaseSection } from '../shared/ProductsShowcaseSection';
import { SparklesIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
export function ExclusiveDeals() {
  const exclusiveProducts = [{
    id: 1,
    name: 'Sunshine Nutrition Vitamin C 1000 mg Orange Flavour Effervescent 20 Tablets',
    brand: 'SUNSHINE NUTRITION',
    price: 10.75,
    originalPrice: 27,
    discount: 60,
    rating: 4.8,
    reviewCount: 1333,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Bioderma Sensibio H2O 500 ml',
    brand: 'BIODERMA',
    price: 39.95,
    originalPrice: 124,
    discount: 68,
    rating: 4.7,
    reviewCount: 128,
    image: PRODUCT_IMAGES[1],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 3,
    name: 'La Roche Posay Anthelios Uvmune400 Sunscreen[SPF50+] 50ml',
    brand: 'LA ROCHE POSAY',
    price: 53.0,
    originalPrice: 140.95,
    discount: 62,
    rating: 4.9,
    reviewCount: 427,
    image: PRODUCT_IMAGES[2],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Mustela Gentle Cleansing Gel Hair & Body 500ml',
    brand: 'MUSTELA',
    price: 37.11,
    originalPrice: 62,
    discount: 40,
    rating: 4.8,
    reviewCount: 601,
    image: PRODUCT_IMAGES[3],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Cerave Sa Smoothing Cleanser 236ml',
    brand: 'CERAVE',
    price: 34.8,
    originalPrice: 82.85,
    discount: 58,
    rating: 4.6,
    reviewCount: 197,
    image: PRODUCT_IMAGES[4],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: "Dexcom G7 Sensor Kit For Continuous Glucose Monitoring, Pack of 1's",
    brand: 'DEXCOM',
    price: 179.0,
    originalPrice: 189,
    discount: 5,
    rating: 4.9,
    reviewCount: 84,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }];
  return <div className="container mx-auto px-4" data-id="element-2180" data-mp="ywv9jec5ofct">
      <ProductsShowcaseSection title="EXCLUSIVE DEALS" subtitle="MEMBERS ONLY" backgroundColor="bg-gradient-to-r from-purple-600 to-indigo-600" products={exclusiveProducts} icon={<SparklesIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-2182" data-mp="18tht7zsqx0d9" />} viewAllLink="#exclusive" data-id="element-2181" data-mp="yxo6jnlbbqhr" />
    </div>;
}